
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.94 0H4.06A4.065 4.065 0 000 4.06v6.88A4.065 4.065 0 004.06 15h6.88A4.065 4.065 0 0015 10.94V4.06A4.065 4.065 0 0010.94 0zm3.18 10.94a3.185 3.185 0 01-3.18 3.18H4.06a3.185 3.185 0 01-3.18-3.18V4.06A3.185 3.185 0 014.06.88h6.88a3.184 3.184 0 013.18 3.18v6.88z"}}),_c('path',{attrs:{"d":"M7.5 3.398A4.106 4.106 0 003.398 7.5 4.106 4.106 0 007.5 11.6 4.106 4.106 0 0011.6 7.5 4.106 4.106 0 007.5 3.398zm0 7.324A3.226 3.226 0 014.278 7.5 3.226 3.226 0 017.5 4.278 3.226 3.226 0 0110.722 7.5 3.226 3.226 0 017.5 10.722zM11.7 1.942c-.669 0-1.212.544-1.212 1.212 0 .668.543 1.212 1.212 1.212.668 0 1.212-.544 1.212-1.212 0-.669-.544-1.212-1.212-1.212zm0 1.544a.333.333 0 110-.666.333.333 0 010 .666z"}})])
          )
        }
      }
    